import React, { useMemo, useState, useEffect } from "react";
import Parse from "parse";
import moment from "moment-with-locales-es6";
import { useNavigate } from "react-router-dom";
import "../../StylesPages/dashboard.css";
import filterImage from "../../filterButton.png";
import ShowUser from "../ShowUser/ShowUser";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  IconButton,
  Image,
  Button,
  Box,
  Text,
  Flex,
  Spacer,
} from "@chakra-ui/react";

export const NewCandidatForOffer = () => {
  const navigate = useNavigate();

  const [posToShow, setPosToShow] = useState(0);
  const [offerPos, setOfferPos] = useState(0);
  const [offers, setOffers] = useState();
  const [offersTitle, setOffersTitle] = useState();
  const [allCandidatsParOffre, setAllCandidatsParOffre] = useState();
  const [candidatsToShow, setCandidatsToShow] = useState();

  moment.locale("fr");

  const showOffer = (key) => {
    setPosToShow(key);
    showCandidats(offerPos[key]);
  };

  const showCandidats = (key) => {
    setCandidatsToShow(allCandidatsParOffre.get(key));
  };

  async function fetchUpdatedOffer() {
    const Offre = Parse.Object.extend("Annonce");
    const query = new Parse.Query(Offre);
    query.equalTo("type", "job");
    const currentUser = Parse.User.current();
    query.equalTo("userId", currentUser);
    query.ascending("dateDebut");
    query.equalTo("isUnseen", true);
    query.notEqualTo("listUnseenUser", []);
    const offres = await query.find().catch((error) => {
      alert(
        "Failed to update user informations, with error code: " + error.message
      );
      Parse.User.logOut();
      navigate("/");
    });

    setOffers(offres);
    let titles = [];
    let ids = [];
    var candidatsParOffre = new Map();
    if (offres !== undefined) {
      offres.forEach((o) => {
        titles.push(o.get("titre"));
        ids.push(o.id);
        candidatsParOffre.set(o.id, o.get("listUnseenUser"));
      });
    }

    setAllCandidatsParOffre(candidatsParOffre);
    setOfferPos(ids);
    setOffersTitle(titles);
    setCandidatsToShow(candidatsParOffre.get(ids[0]));
    console.log(candidatsParOffre);
    // showOffer(0);
    return offres;
  }

  useEffect(() => {
    fetchUpdatedOffer();
  }, []);

  return (
    <Box h={"300px"}>
      <Flex>
        <Text
          fontFamily={"Sofia Pro"}
          fontSize={"2xl"}
          fontWeight={"bold"}
          align="left"
          p={4}
        >
          Nombre de candidatures
        </Text>
        <Spacer />
        <Menu>
          <MenuButton pr={4}>
            <Image align={"right"} src={filterImage}></Image>
          </MenuButton>
          <MenuList>
            {offersTitle
              ? offersTitle.map((o, k) => {
                  return (
                    <MenuItem key={k} onClick={() => showOffer(k)}>
                      {" "}
                      {o}{" "}
                    </MenuItem>
                  );
                })
              : ""}
          </MenuList>
        </Menu>
      </Flex>

      {candidatsToShow ? (
        <Box display={"flex"}>
          <Text
            fontFamily={"Sofia Pro"}
            fontSize={"14px"}
            fontStyle={"normal"}
            fontWeight={300}
            pt={2.5}
            align="left"
            ms={"30px"}
          >
            vous avez reçu
          </Text>
          <Text
            fontFamily={"Sofia Pro"}
            fontSize={"24px"}
            fontStyle={"normal"}
            fontWeight={900}
            align="left"
            ms={"5px"}
          >
            {candidatsToShow.length} candidatures
          </Text>
        </Box>
      ) : (
        ""
      )}
      <Box>{offersTitle ? offersTitle[posToShow] : ""}</Box>
      <br></br>
      <Box maxH={["120px", "120px", "150px", "150px"]} overflowY={"auto"}>
        {candidatsToShow
          ? candidatsToShow.map((userId) => {
              return (
                <Box key={userId} ml={"20px"}>
                  <ShowUser
                    offre={offers[posToShow]}
                    hide={true}
                    showMetier={true}
                    showAvatarOnly={false}
                    userId={userId}
                    unseen={offers[posToShow]
                      .get("listUnseenUser")
                      .includes(userId)}
                  ></ShowUser>
                </Box>
              );
            })
          : ""}
      </Box>
    </Box>
  );
};

export default NewCandidatForOffer;
